import { RowDatumCell } from './datum-cell.model';

export class TableRow {
  constructor(
    public datumCells: Array<RowDatumCell>,
    public countCells: { [columnId: string]: number },
    public subtotal = false,
    public colspan?: number
  ) {}
}
